import { APIAddress, APIRequest } from "@companion-core/shared/app/Interfaces/API";

export interface RequestCardProps {
  data: APIRequest;
  accessibilityLabel?: string;
  path?: string;
  onClick?: () => void;
  onPress?: () => void;
}

export function isEqualLocation(location1: APIAddress, location2: APIAddress) {
  return (Object.keys(location1) as (keyof APIAddress)[]).every(
    (key) => location1[key] === location2[key]
  );
}
